module.exports = __webpack_public_path__ + "Lato-BoldItalic.d3b517b62bcaaeb19c1d.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BoldItalic.woff
// module id = ../../../../../src/assets/fonts/Lato-BoldItalic.woff
// module chunks = styles